<template>
<div class="animated">
  <PatronCard
      v-if="!patron"
      :patron="patron"
      :add_premium="add_premium"
      :feature="levelsFeature"
    />
    <div :class="{ 'premium-locked-ui': !patron }">
  <b-row>
  <!-- ================= AUTO PURGE ================= -->
  <b-col sm="12" md="6">

    <b-card v-if="!loading">
      <div slot="header">
        <i class="icon-trash"></i> Auto Purge
      </div>

      <h4 class="smalltitle">
        Automatic Message Cleanup
      </h4>
      <hr />
      <p>
        Automatically purge messages from configured channels at a fixed interval.
      </p>
        <div>
          <h6>Channel</h6>
          <multiselect
            v-model="autopurge.channel"
            track-by="id"
            label="name"
            placeholder="Select a channel"
            open-direction="bottom"
            :clear-on-select="false"
            :close-on-select="true"
            :max-height="600"
            :show-no-results="false"
            :hide-selected="false"
            :options="ungroupedChannels"
            :allow-empty="true"
            group-values="channels"
            group-label="category"
            :group-select="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <span class="option__desc">
                <font-awesome-icon
                  style="color:#72767d"
                  icon="hashtag"
                />
                <span class="option__title ml-2">
                  {{ props.option.name }}
                </span>
              </span>
            </template>

            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">
                  <font-awesome-icon
                    style="color:#72767d"
                    :icon="!props.option['$isLabel'] ? 'hashtag' : 'chevron-down'"
                  />
                  {{ props.option.name || props.option.$groupLabel.name }}
                </span>
              </div>
            </template>
          </multiselect>

          <hr />

          <h6>Repeat Every</h6>

          <b-row>

            <b-input-group class="col-sm-6 my-1">
              <b-form-input
                type="number"
                min="0"
                max="14"
                placeholder="0"
                v-model="autopurge.interval.days"
                @keydown="handleOnlyNumberkeyInput"
              ></b-form-input>

              <b-input-group-append>
                <b-input-group-text>
                  Days
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>

            <b-input-group class="col-sm-6 my-1">
              <b-form-input
                type="number"
                min="0"
                max="23"
                placeholder="0"
                v-model="autopurge.interval.hours"
                @keydown="handleOnlyNumberkeyInput"
              ></b-form-input>

              <b-input-group-append>
                <b-input-group-text>
                  Hours
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>

          </b-row>

          <small class="text-muted">
            Minimum interval: <b>1 hour</b> • Maximum: <b>14 days</b>
          </small>
          <hr />
          <h6>Message Type</h6>

          <multiselect
            v-model="autopurge.message_type"
            :options="autopurgemessage_type"
            :multiple="false"
            label="name"
            track-by="value"
            placeholder="All messages"
            :allow-empty="true"
          >

            <template slot="singleLabel" slot-scope="props">
              {{ props.option.name }}
            </template>

            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">
                  {{ props.option.name }}
                </span>
              </div>
            </template>

          </multiselect>

          <small class="text-muted">
            Leave empty to purge all messages.
          </small>
          <hr />
        </div>
      </fieldset>

      <div slot="footer">
        <b-button
          variant="primary"
          @click="autopurge_settings"
        >
          Save
        </b-button>
      </div>

    </b-card>

  </b-col>

  <!-- ================= AUTO PURGE LIST ================= -->
  <b-col sm="12" md="6">

    <b-card v-if="!loading">

      <div slot="header">
        <i class="icon-list"></i>
        Auto Purge List

      </div>
      <p>
        Upto 15 channels can be configured.
      </p>

      <div
        v-if="!autopurgeList || autopurgeList.length === 0"
        class="text-center text-muted py-4"
      >
        No AutoPurge channels configured.
      </div>
      <b-list-group
        v-else
        flush
      >
        <b-list-group-item
          v-for="item in autopurgeList"
          :key="item.channel">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="mb-1">
                #{{ getChannelName(item.channel) }}
              </h6>
              <small class="text-muted d-block">
                Every {{ item.interval.days }}d {{ item.interval.hours }}h
              </small>
              <small class="text-muted d-block">
                  message_type:
                  {{ item.message_type && item.message_type.length
                      ? item.message_type[0]
                      : 'All Messages' }}
                </small>
              <small class="text-muted d-block">
                Next Purge:
                {{ formatNextPurge(item.next_run) }}
              </small>
            </div>
            <b-button
              size="sm"
              variant="outline-danger"
              @click="removeAutopurge(item.channel)"
            >
              Remove
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </b-col>
</b-row>
  </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Switch as cSwitch } from "@coreui/vue";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { createTags, VueTagsInput } from "@johmun/vue-tags-input";
import Multiselect from "vue-multiselect";
import PatronCard from "@/views/oc/PatronCard";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn",
};
miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const toast_options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

const reducer = (accumulator, currentValue, currentIndex) =>
  accumulator + (currentValue << currentIndex);

Vue.use(VueNotifications, toast_options);


export default {
  name: "Autopurge",
  components: {
    cSwitch,
    VueTagsInput,
    Multiselect,
    PatronCard,
  },
  data: function () {
    return {
      roles: [],
      channels: [],

      autopurgeList: [],
      autopurge: {
          channel: null,

          interval: {
            days: 0,
            hours: 1
          },

          message_type: null
        },

        autopurgemessage_type: [
          { name: "Links", value: "links" },
          { name: "Invites", value: "invites" },
          { name: "Attachments", value: "attachments" },
          { name: "Bot Messages", value: "bots" },
          { name: "Human Messages", value: "humans" }
        ],
      patron: true,
      levelsFeature: {
        icon: "icon-trash",
        title: "Auto Purge",
        tagline:
          "The Auto Purge feature allows you to purge a specific channel of messages at a set interval.",
        points: [
          "Upto 15 channels can be configured ",
          "Multiple message_type support for different message types.",
          "Each run scans up to 1000 recent messages.",
          "From 1 hour to 14 days can be configured for auto purge.",
        ],
      },

      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Success!",
      message: "Setting applied",
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.axios
      .get("/api/v1/servers/" + this.$route.params.guild_id + "/autopurge")
      .then((r) => {});
  },
  methods: {

add_premium() {
      return this.axios
        .post("/api/v1/servers/" + this.$route.params.guild_id + "/patron", {})
        .then(r => {
          this.patron = true;
        });
    },
autopurge_settings() {
  if (!this.autopurge.channel) {
    miniToastr.error("Please select a channel.");
    return;
  }

  const days = Number(this.autopurge.interval.days);
  const hours = Number(this.autopurge.interval.hours);

  this.axios
    .put(
      "/api/v1/servers/" + this.$route.params.guild_id + "/autopurge",
      {
        autopurge: {
          channel: this.autopurge.channel.id,
          interval: {
            days,
            hours,
          },
          message_type: this.autopurge.message_type
            ? this.autopurge.message_type.value
            : null,
        },
      }
    )
    .then(() => {
      this.showSuccessMsg();

      this.autopurge = {
        channel: null,
        interval: {
          days: 0,
          hours: 1,
        },
        message_type: null,
      };

      this.reloadAutopurge();
    });
},
      reloadAutopurge() {
  return this.axios
    .get(
      "/api/v1/servers/" +
      this.$route.params.guild_id +
      "/autopurge"
    )
    .then((r) => {

      this.autopurgeList =
        r.data.settings &&
        Array.isArray(r.data.settings.autopurge)
          ? r.data.settings.autopurge
          : [];
    });
},

removeAutopurge(channelId) {
  this.axios
    .delete(
      "/api/v1/servers/" + this.$route.params.guild_id + "/autopurge",
      {
        data: {
          autopurge: {
            channel: channelId,
          },
        },
      }
    )
    .then(() => {
      // Remove the deleted channel from the local list
      this.autopurgeList = this.autopurgeList.filter(
        item => String(item.channel) !== String(channelId)
      );

      this.showSuccessMsg();
    })
    .catch((error) => {
      console.error("Failed to remove AutoPurge:", error);
      miniToastr.error("Failed to remove AutoPurge.");
    });
},

getChannelName(id) {

  const ch = this.channels.find(x => x.id == id);

  return ch ? ch.name : "Unknown";

},

formatNextPurge(date) {

  if (!date)
    return "Unknown";

  return new Date(date).toLocaleString();

},
    put_settings(obj) {
      this.axios
        .put("/api/v1/servers/" + this.$route.params.guild_id + "/autopurge", obj)
        .then(this.showSuccessMsg());
    },

  },
  created: function () {
    this.$Progress.start();
    this.axios
      .get("/api/v1/servers/" + this.$route.params.guild_id + "/autopurge")
      .then((r) => {
        this.channels = r.data.channels;

        this.autopurgeList = r.data.settings.autopurge || [];
        this.loading = false;
        this.$Progress.finish();
        this.patron = r.data.is_patron;


      });
  },
  computed: {
    isPremium() {
      return !!(this.$store.state.globalInfo && this.$store.state.globalInfo.isPremium);
    },

    ungroupedChannels() {
  let groups = [
    {
      category: { id: null, name: "Uncategorized" },
      channels: [],
    },
  ];

  // ✅ sort ONLY ONCE
  let sortedChannels = [...this.channels].sort(
    (a, b) => a.position - b.position
  );

  let map = new Map();
  map.set(null, groups[0]);

  let currentGroup = groups[0];

  // create category groups
  for (let chn of sortedChannels) {
    if (chn.type === 4) {
      currentGroup = { category: chn, channels: [] };
      groups.push(currentGroup);
      map.set(chn.id, currentGroup);
    }
  }

  // assign channels
  for (let chn of sortedChannels) {
    if (chn.type === 4) continue;

    let group = map.get(chn.parent_id);
    if (group) {
      group.channels.push(chn);
    }
  }

  return groups;
},
    groupedChannels() {
  let allOptions = [];

  // ✅ sort once
  let sortedChannels = [...this.channels].sort(
    (a, b) => a.position - b.position
  );

  let categoriesMap = new Map();

  // collect categories
  for (let chn of sortedChannels) {
    if (chn.type === this.guild_category) {
      categoriesMap.set(chn.id, {
        category: chn,
        channels: [],
      });
    }
  }

  let uncategorizedChannels = [];

  // assign channels
  for (let chn of sortedChannels) {
    if (chn.type === this.guild_category) continue;

    if (chn.parent_id === null) {
      uncategorizedChannels.push(chn);
    } else if (categoriesMap.has(chn.parent_id)) {
      categoriesMap.get(chn.parent_id).channels.push(chn);
    }
  }

  // build final list
  uncategorizedChannels.forEach((ch) => allOptions.push(ch));

  categoriesMap.forEach(({ category, channels }) => {
    allOptions.push({ ...category, isCategory: true });
    channels.forEach((ch) => allOptions.push(ch));
  });

  return [
    {
      category: { id: null, name: "All" },
      channels: allOptions,
    },
  ];
},
  },
};
</script>
<style lang="css">
.vue-tags-input {
  background: #505b64;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent;
  color: #b7c4c9;
}

div.vue-tags-input {
  background: #505b64 !important;
}

.vue-tags-input .ti-input {
  padding: 4px 10px;
  transition: border-bottom 200ms ease;
  border: 1px solid #222823;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #606bb6;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #283944;
  border-top: none;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item.ti-selected-item {
  background: #ebde6e;
  color: #283944;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative;
  background: #5e6bbb;
  color: #eee;
}

/* we defined a custom css class in the data model, now we are using it to style the tag */
.vue-tags-input .ti-tag.custom-class {
  background: transparent;
  border: 1px solid #5e6bbb;
  color: #5e6bbb;
  margin-right: 4px;
  border-radius: 0px;
  font-size: 13px;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}

.premium-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 9px;
  margin-left: 8px;
  background: rgba(248, 203, 0, 0.12);
  border: 1px solid rgba(248, 203, 0, 0.4);
  color: #f8cb00;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 999px;
  text-decoration: none;
  vertical-align: middle;
}
.premium-pill:hover {
  background: rgba(248, 203, 0, 0.2);
  color: #ffd83d;
  text-decoration: none;
}
.premium-pill i {
  font-size: 9px;
}
.premium-locked-ui {
  opacity: 0.55;
  pointer-events: none;
  user-select: none;
}
</style>
<style src="spinkit/spinkit.min.css"></style>
